import React, {type ReactNode, type RefObject} from 'react'
import {linkParts} from '@/Pages/Events/Assistant/assistantTranscript'

interface Props {
    text: string
    className: string
    testId?: string
    hidden?: boolean
    tabIndex?: number
    paragraphRef?: RefObject<HTMLParagraphElement | null>
}

const LinkedText = ({
    text,
    className,
    testId,
    hidden = false,
    tabIndex,
    paragraphRef,
}: Props): ReactNode => {
    const parts = linkParts(text)
    const pieces: ReactNode[] = []
    let offset = 0

    for (const part of parts) {
        const key = offset
        offset += part.text.length

        pieces.push(part.href === undefined ? (
            <span key={key}>{part.text}</span>
        ) : (
            <a
                key={key}
                href={part.href}
                target="_blank"
                rel="noreferrer"
                className="break-all text-royal-10 underline underline-offset-2 focus-visible:rounded-sm focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-royal-20"
            >
                {part.text}
            </a>
        ))
    }

    return (
        <p
            ref={paragraphRef}
            tabIndex={tabIndex}
            data-testid={testId}
            aria-hidden={hidden ? true : undefined}
            className={className}
        >
            {pieces}
        </p>
    )
}

export default LinkedText
